/*
 * Site: {SITE}
 * File: custom/snippets
 * ============================================================================
 * Some description...
 * ============================================================================
 * Built by Xanthe Studios | xanthestudios.co.uk
 * ============================================================================
 */

/**
 * Some description...
 */

if ($('html').hasClass('touchevents')) {

	$('.l-site-header .c-form--search i').click(function(e) {

		$(this).css('display', 'none');

		$(this).siblings('.o-button').css('display', 'block');

		$(this).siblings('.o-field').addClass('is-visible');

	});

} else {

	$('.l-site-header .c-form--search .o-button').hover(function() {

		$(this).siblings('.o-field').addClass('is-visible');

	});

	$('.l-site-header .c-form--search').mouseleave(function() {

		$(this).children('.o-field').removeClass('is-visible');

	});

}
